import {
  GET_UNIQUE_PASS_TOKEN,
  GET_UNIQUE_PASS_TOKEN_ERROR,
  GET_USER_INFO,
  GET_USER_INFO_ERROR,
  GET_USER_INFO_SUCCESS,
  GET_SIGNER_UNIQUE_PASS_INFO,
  GET_SIGNER_UNIQUE_PASS_INFO_ERROR,
  GET_SIGNER_UNIQUE_PASS_INFO_SUCCESS
} from './UniquePassAuth.actions'

const uniquePassAuthState = {
  loading: true,
  error: null,
  data: null
}

/**
 * The unique pass auth's reducer.
 */
const uniquePassAuthReducer = (state = uniquePassAuthState, { payload, type }) => {
  switch (type) {
    case GET_UNIQUE_PASS_TOKEN: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_UNIQUE_PASS_TOKEN_ERROR: {
      return {
        ...state,
        loading: false,
        error: payload.error
      }
    }
    case GET_USER_INFO: {
      return { ...state, loading: true, error: null }
    }
    case GET_USER_INFO_ERROR: {
      return {
        ...state,
        error: payload.reason,
        loading: false
      }
    }
    case GET_USER_INFO_SUCCESS: {
      return {
        ...state,
        loading: false,
        guest: {
          ...state.guest,
          dni: payload.dni,
          name: payload.name,
          lastName: payload.lastName,
          phone: payload.phone,
          gender: payload.gender,
          isUniquePass: 1
        }
      }
    }
    case GET_SIGNER_UNIQUE_PASS_INFO: {
      return { ...state, loading: true, error: null }
    }
    case GET_SIGNER_UNIQUE_PASS_INFO_ERROR: {
      return {
        ...state,
        error: payload.reason,
        loading: false
      }
    }
    case GET_SIGNER_UNIQUE_PASS_INFO_SUCCESS: {
      return {
        ...state,
        loading: false,
        signerUniquePass: {
          ...state.signerUniquePass,
          dni: payload.dni,
          name: payload.name,
          lastName: payload.lastName,
          phone: payload.phone,
          gender: payload.gender
        }
      }
    }
    default: {
      return state
    }
  }
}

export default uniquePassAuthReducer
